import React from "react";
import LegalPage, { useLegalLabels } from "./LegalPage";
import { termsContent } from "./legalContent";
import { useLang } from "@/i18n/LanguageContext";

const TermsPage = () => {
  const { t } = useLang();
  const { back, lang } = useLegalLabels();
  return (
    <LegalPage
      testId="terms-page"
      updated={t.terms.updated}
      title={t.terms.title}
      sections={termsContent[lang]}
      backLabel={back}
    />
  );
};

export default TermsPage;
